import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g2,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_rgbw_plus from '@devices/settings/device_settings/safety_rgbw_plus.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import rgbw_settings_gen_2 from '@devices/settings/device_settings/rgbw_settings_gen_2.js';
import rgbw_all_settings_gen_2_rgbw from '@devices/settings/common_settings/rgbw_all_settings_gen_2_rgbw';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

export default {
	name: 'ShellyPlusRGBWPM',
	friendly_name: 'Plus RGBW PM',
	family: 'light',
	isPM: true,
	addons: addon_plus_devices_g2,
	reset_from_input: true,
	modes: {
		light: {
			channels: 4,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				safety_rgbw_plus,
				app_setting_plus_rgbw_gen_2,
				share,
				rgbw_settings_gen_2,
			],
		},
		rgb: {
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			color: true,
			slider: 'brightness',
			has_white: false,
			brightness: 0,
			settings: rgbw_all_settings_gen_2_rgbw,
		},
		rgbw: {
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			color: true,
			slider: 'brightness',
			brightness: 0,
			has_white: true,
			settings: rgbw_all_settings_gen_2_rgbw,
		},
	},
};
